export {
    default as useActiveRouteName,
    getDeepActiveRouteName,
    ACTIVE_ROUTE_EVENTS,
    getActiveRouteName,
    getNavigationState,
    getRouteTargetName,
    hasActiveRoute,
    isRouteActive
} from "./activeRoute";

export type {
    DeepActiveRouteNameConstantType,
    NavigationStateConstantType,
    RouteTargetNameConstantType,
    ActiveRouteConstantType,
    ActiveRouteItemType
} from "./activeRoute";
